import {
    BaseError,
} from 'wanderu-utils';

export default class OverQueryLimit extends BaseError {
    constructor() {
        super('Over query limit');
    }
}
